import { createIconDefinition } from '../../../../cross-team-shared/icons/create-icon-definition';

export const arrowIcon = createIconDefinition(
  'arrow',
  `<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M11.6661 3.33301H17.4994C17.7628 3.33301 18.0107 3.45756 18.168 3.6689C18.3252 3.88024 18.3733 4.15349 18.2976 4.4058L16.8081 9.37065L15.2117 8.89174L15.9515 6.426L3.011 16.4908C2.64772 16.7734 2.12415 16.7079 1.84159 16.3446C1.55904 15.9813 1.62448 15.4578 1.98777 15.1752L15.0706 4.99967H11.6661V3.33301Z" fill="#232426" fill-opacity="0.6"/>
</svg>`,
);
